"use client";

import { useTranslations } from "next-intl";

import { PrimAccordion } from "@/shared-web.ui/prim.accordion";

import { SectionTitle } from "./prim.subscription-detail-section-layout";

interface FaqSectionProps {
  faqs: { question: string; answer: string }[];
}
const FaqSection = (props: FaqSectionProps) => {
  const { faqs } = props;
  const t = useTranslations("stf_m_subscription.screen_subscription.faq_section");

  return (
    <div className="mx-auto w-full max-w-4xl p-6">
      <SectionTitle>
        {t("frequently_asked_questions")}
      </SectionTitle>
      <PrimAccordion.Root
        type="single"
        collapsible
        className="w-full py-6"
      >
        {faqs.map((faq) => {
          return (
            <PrimAccordion.Item key={faq.question} value={faq.question}>
              <PrimAccordion.Trigger className={`
                text-3 font-regular text-left
              `}
              >
                {faq.question}
              </PrimAccordion.Trigger>
              <PrimAccordion.Content className={`
                whitespace-pre-line
              `}
              >
                {faq.answer}
              </PrimAccordion.Content>
            </PrimAccordion.Item>
          );
        })}
      </PrimAccordion.Root>
    </div>
  );
};

export { FaqSection };
